import consumer from "./consumer"

let syncStateWas;

consumer.subscriptions.create("SyncStatusChannel", {
  received(detail) {
    if (syncStateWas && syncStateWas !== "synced" && detail.state === "synced") {
      console.info("Sync completed, reloading page…");
      window.setTimeout(() => window.location.reload(), 1000);
    } else {
      syncStateWas = detail.state;
    }

    document.querySelectorAll("[data-sync-state]").forEach((element) => {
      element.setAttribute("data-sync-state",      detail.state);
      element.setAttribute("data-sync-progress",   detail.progress);
      element.style.setProperty("--sync-progress", detail.progress);

      if (detail.month) {
        element.setAttribute("data-sync-month", detail.month);
      } else {
        element.removeAttribute("data-sync-month");
      }

      if (detail.year) {
        element.setAttribute("data-sync-year", detail.year);
      } else {
        element.removeAttribute("data-sync-year");
      }
    });

    const event = new CustomEvent("syncStateUpdated", { detail });
    document.dispatchEvent(event);
  }
});
